import React, { useContext, useState } from 'react'
const LocaleSpecificContext = React.createContext<string>('')
const LocaleSpecificUpdateContext = React.createContext<any>(undefined)

export function useLocaleSpecificContext() {
  return useContext(LocaleSpecificContext)
}

export function useLocaleSpecificUpdateContext() {
  return useContext(LocaleSpecificUpdateContext)
}

export function LocaleSpecificProvider({ children }: any) {
  const [locale, setLocale] = useState('us-AL')

  function changeLocale(locale: string) {
    setLocale(locale)
  }

  return (
    <LocaleSpecificContext.Provider value={locale}>
      <LocaleSpecificUpdateContext.Provider value={changeLocale}>
        {children}
      </LocaleSpecificUpdateContext.Provider>
    </LocaleSpecificContext.Provider>
  )
}
